<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('es')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;Spanish</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fa')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/fa.png" alt="fa" />  Persian</vs-dropdown-item>
      <!--      <vs-dropdown-item @click="updateLocale('de')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;German</vs-dropdown-item>-->
      <!--      <vs-dropdown-item @click="updateLocale('pt')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;Portuguese</vs-dropdown-item>-->
    </vs-dropdown-menu>
  </vs-dropdown>

</template>

<script>
  import VueCookies from 'vue-cookies'
  export default {
    computed: {
      i18n_locale_img () {
        return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
      },
      getCurrentLocaleData () {
        const locale = this.$i18n.locale
        if (locale === 'en') {this.$vs.rtl=false; return({ flag: 'us', lang: 'English', rtl:false  })}
        else if (locale === 'es') {this.$vs.rtl=false;return({ flag: 'es', lang: 'Spanish', rtl:false  })}
        else if(locale === 'fa') {this.$vs.rtl=true;return ({ flag: 'fa', lang: 'Persian', rtl:true })}
      }
    },

    methods: {
      updateLocale (locale) {
        this.$i18n.locale = locale
        window.$cookies.set('locale', locale, Infinity);
        window.location.reload();
      }
    },
  }
</script>
